<template>
  <div>
    <!-- 弹窗-添加/修改 -->
    <simple-modal 
      ref    ="modal"
      :title ="title"
      :right ="true"
      :middle="true"
      @submit="submit"
    >
      <template slot="body">
        <!--  -->
        <div>
          <common-form-item 
            :labelweight="165"
            v-for="item in formItem" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
          </common-form-item >
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
export default {
  name: "modal-dept",
  props:["organi", "deptData"],
  data() {
    return{
      showEmail: false,
      title:"",
      type :"add",
      formData: new FormClass({ // 弹窗-表单数据
        parent_id: 0,
        home_id :  this.organi,
        name : {
          init: "",
          check: "smallstr",
          errormsg: this.$I18n("pls_input_dept_name"),
        },
      }),
      depts: [],
    }
  },
  mounted(){ },
  computed: {
    slimDeptData(){
      return this.deptData.map(one => {
        return {
          ...one,
          children: one.children ?one.children.map(two => {
            return {
              ...two,
              children: [],
            }
          }) :[],
        }
      })
    },
    formItem(){
      return[
        {
          label  : this.$I18n("name_dept"),
          keys     : "name",
          type     : "input",
          check    : true,
          required : true,
          placeholder: this.$I18n("pls_enter_name_dept"),
        },{
          label  : this.$I18n("high_author"),
          keys     : "parent_id",
          type     : "filter-tree-select",
          // check    : true,
          // required : true,
          options  : this.slimDeptData,
          disabled  : this.type === 'edit',
          placeholder: this.$I18n("pls_select_high_author"),
        },
      ]
    },
  },
  methods:{
    /*
      type : add | edit | del
      data : 表单基础数据
    */
    open(type, data){
      this.type = type;
      this.depts = this.UserInfo.depts;
      if(type === "add"){
        this.$refs.modal.open();
        this.formData.Reset();
        this.title = this.$I18n("add_dept")

      } else if(type === "edit"){
        this.$refs.modal.open();
        this.formData.Update(data);
        this.title = this.$I18n("edit_dept")
      
      } else if(type === "del"){
        this.formData.Update(data);
        this.$confirm(this.$I18n("conf_del"), this.$I18n("del_dept"), {
          confirmButtonText: this.$I18n("sure"),
          cancelButtonText : this.$I18n("cancle"),
          type: 'warning'
        }).then(() => {
          this.submit();
        }).catch(() => { })
      }
    },
    submit(){
      if(this.type === "add"){
        this.add();
      } else if(this.type === "edit"){
        this.edit();
      } else if(this.type === "del"){
        this.del();
      }
    },
    // 调用父组件传递的close方法
    close(){
      this.$refs.modal.close();
      if(this.$listeners["close"]){
       this.$emit('close', this.type);
      }
    },
    add(){
      if(this.formData.Check()){
        this.$errorMsg(this.formData.ErrMsg ?this.formData.ErrMsg :this.$I18n("pls_check_verify"))
        return 
      }
      this.$api.a_OrganiDepart(this.formData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("add_success"));
          this.close();
        }))
        .catch(err => {
          // 8020 ->有子部门
          if(err.code === 8015){
            this.$errorMsg(this.$I18n("error_code_8015"))
          } else {
            this.$errorMsg(this.$I18n("add_fail") + `[${err.code}]`)
          }
        })
    },
    edit(){
      if(this.formData.Check()){
        this.$errorMsg(this.formData.ErrMsg ?this.formData.ErrMsg :this.$I18n("pls_check_verify"))
        return 
      }
      this.$api.s_OrganiDepart(this.formData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.close();
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))

    },
    del(){
      this.$api.d_OrganiDepart(this.formData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"));
          this.close();
        }))
        // error_code_8017
        .catch(err => {
          // 8020 ->有子部门
          if(err.code === 8017){
            this.$errorMsg(this.$I18n("error_code_8014"))
          } else {
            this.$errorMsg(this.$I18n("delete_fail") + `[${err.code}]`)
          }
        })
    },
  },
}
</script>

<style scoped></style>